import { objectsEqual } from "../object/objectsEqual.js";
function arraysEqual(a1, a2) {
  if (a1.length !== a2.length) {
    return false;
  }
  return a1.every((item, index) => objectsEqual(item, a2[index]));
}
export {
  arraysEqual
};
